import { Component, OnInit, ViewChild, SimpleChanges, SimpleChange } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { NgForm } from '@angular/forms';
import { UtilService } from '../service/util.service';
import { ApiService } from '../service/api.service';
import { Constants } from '../constants/constants';
import { ToastService } from '../service/toast.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-account-billing-profile',
  templateUrl: './account-billing-profile.component.html',
  styleUrls: ['./account-billing-profile.component.scss']
})
export class AccountBillingProfileComponent implements OnInit {

  @ViewChild('billingForm', { static: true }) public billingForm: NgForm;

  invoiceCreationOptions: Array<string> = ["AUTO", "MANUAL"];

  billingModal = null;
  masterBillingData = null;
  invalidZipCode: boolean = false;
  stateList: Array<any> = new Array();
  editAddress: boolean = false;

  constructor(private apiService: ApiService, public authService: AuthenticationService, public utilService: UtilService, private toastService: ToastService) {
  }

  ngOnDestroy() { }

  ngOnInit() {
    this.initBillingModal();
    this.getStateList();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  getBillingProfile() {
    this.utilService.showSpinner();
    this.apiService.getBillingProfile().then((data) => {
      this.utilService.hideSpinner();
      console.log("billing profile from API: ", data);
      this.setBillingModal(data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getBillingProfile();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  setBillingModal(data) {

    this.billingModal = {
      "billingCycle": data.billingCycle,
      "billingDate": data.billingDate,
      "paymentTerm": data.paymentTerm ? data.paymentTerm : 21,
      "currency": data.currency,
      "isAccountAddress": data.isAccountAddress,
      "address": data.address,
      "invoiceCreation": data.invoiceCreation ? data.invoiceCreation : this.invoiceCreationOptions[0]
    };
    if(isNullOrUndefined(data.address)) {
      this.billingModal.address = {
        "street": null,
        "city": null,
        "zipCode": null,
        "state": null,
        "plus4Code": null
      };
    }
    this.masterBillingData = JSON.parse(JSON.stringify(this.billingModal));
  }

  initBillingModal() {
    this.billingModal = {
      "billingCycle": "MONTHLY",
      "billingDate": 1,
      "paymentTerm": 21,
      "currency": this.utilService.countryData.currency,
      "isAccountAddress": false,
      "address": {
        "street": null,
        "city": null,
        "zipCode": null,
        "state": null,
        "plus4Code": null
      },
      "invoiceCreation": this.invoiceCreationOptions[0]
    };

    this.invalidZipCode = false;
    this.editAddress = false;
  }

  getStateList() {
    // this.utilService.showSpinner();
    this.apiService.getUsStateList().then((data) => {
      // this.utilService.hideSpinner();
      this.stateList = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          // this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getStateList();
        });
      }
      else {
        // this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getZipCodeDetails(zipCode) {

    if (zipCode.length == 5) {
      this.apiService.getZipCodeDetails(zipCode).then((data) => {
        console.log("zip code detail data from api : ", data);
        this.invalidZipCode = false;
        this.billingModal.address.state = data.places[0]["state abbreviation"];
        this.billingModal.address.city = data.places[0]["place name"];

      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_NOT_FOUND) {
          this.invalidZipCode = true;
        } else if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
      });
    } else {
      this.invalidZipCode = false;
      this.billingModal.address.state = null;
      this.billingModal.address.city = null;
    }
  }
  
  saveClicked(form: NgForm) {
    if (form.valid) {

      var payload = {
        "isAccountAddress": this.billingModal.isAccountAddress,
        "address": this.billingModal.address
      }

      if (payload.address.plus4Code == "") {
        payload.address.plus4Code = null;
      }

      if (payload.isAccountAddress) {
        delete payload["address"];
      }

      console.log("Update clicked : ", payload);
      this.updateBillingAddress(payload);
    }
  }

  updateBillingAddress(payload) {
    this.utilService.showSpinner();
    this.apiService.updateBillingAddress(payload).then((data) => {
      this.utilService.hideSpinner();
      console.log("billing address update response::", data);
      this.setBillingModal(data);
      this.editAddress = !this.editAddress;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.updateBillingAddress(payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onEdit() {
    this.editAddress = !this.editAddress;
  }

  onCancelEdit() {
    this.editAddress = !this.editAddress;
    this.invalidZipCode = false;
    this.billingModal = JSON.parse(JSON.stringify(this.masterBillingData));
  }
  
  cancelClicked(){
    this.editAddress = false;
    this.invalidZipCode = false;
    this.resetForm();
  }
  
  resetForm() {
    this.billingForm.reset();
    this.billingForm.resetForm();
  }
}